import { useEffect } from 'react';
import { ISilhouetteParameters } from './silhouette-interfaces';
import { useSilhouetteStore } from './dal/silhouette-store';
import SilhouetteParameters from './ui/parameters';
import SilhouetteView from './ui/view';

const initialParameters: ISilhouetteParameters = {
    cluster1: [
        [0,0],
        [0,1],
        [2,3],
    ],
    cluster2: [
        [3,3],
        [3,4],
    ]
};

const SilhouetteHome = () => {

    const params = useSilhouetteStore(store => store.params);
    const setParams = useSilhouetteStore(store => store.setParams);

    useEffect(() => {
        setParams(initialParameters);
    }, [setParams]);

    return(
        <div className="w-full py-2 overflow-auto">

            <div className="w-full mb-4">
                <h1 className="text-2xl px-2 mb-4">Силуэт (ניתוח אשכולות)</h1>

                {
                    params &&
                    <div className="flex gap-4 ml-2">
                        <SilhouetteParameters />
                        <SilhouetteView />
                    </div>
                }
            </div>

        </div>
    )
};

export default SilhouetteHome;
